// This is a generated TS file, see tasks/js-to-less
var TscStyles = {
  color: {
    global: {
      white: '#FFFFFF',
      boxShadow: 'rgba(0,0,20,.25)',
      overlay: 'rgba(0,0,10,.6)',
      transparent: 'transparent'
    },
    brand: {
      techsmith: '#FFC82E',
      camtasia: '#98C92D',
      cloud: '#26ABA5',
      fuse: '#E63124',
      jing: '#FFC82E',
      morae: '#106470',
      relay: '#0072CF',
      screencast: '#EF8200',
      snagit: '#448CCB',
      audiate: '#352683'
    },
    ui: {
      dawn: {
        light: '#FFFFFF',
        lightMedium: '#F5F6F8',
        medium: '#DADEE2',
        mediumDark: '#C0C7CB',
        dark: '#A7B1B7'
      },
      dusk: {
        light: '#A7B1B7',
        lightMedium: '#636A70',
        medium: '#2A3137',
        mediumDark: '#1F242A',
        dark: '#15191C'
      }
    },
    text: {
      light: '#F5F6F8',
      lightMedium: '#9EA8AE',
      medium: '#4F636E',
      mediumDark: '#2E3940',
      dark: '#15191C'
    },
    action: {
      primary: '#0072CF',
      secondaryDawn: '#E8E9EB',
      secondaryDusk: '#3B444C',
      destructive: '#CD4242',
      affirmative: '#36BE5F',
      cta: '#077e7e',
      camtasiaPrimary: '#739922',
      screencastPrimaryStop1: '#FABF5A',
      screencastPrimaryStop1Hover: '#FFC96E',
      screencastPrimaryStop2: '#E08C00',
      screencastPrimaryStop2Hover: '#ED9A11'
    },
    message: {
      info: '#0072cf',
      caution: '#EBAE21',
      warning: '#E64848',
      affirmative: '#36BE5F'
    },
    modifier: {
      light: '#FFFFFF',
      dark: '#000022'
    }
  },
  font: {
    family: {
      primary: 'Figtree, \'Helvetica Neue\', Helvetica, Arial, sans-serif'
    },
    weight: {
      regular: '400',
      semibold: '600'
    },
    style: {
      normal: 'normal',
      italic: 'italic'
    },
    size: {
      tiny: '0.625rem',
      small: '0.75rem',
      regular: '0.875rem',
      large: '1rem',
      huge: '1.125rem'
    }
  },
  space: {
    tiny: '0.25rem',
    small: '0.5rem',
    medium: '1rem',
    large: '1.5rem',
    huge: '2rem'
  },
  border: {
    radius: {
      xxs: '2px',
      xs: '4px',
      sm: '6px',
      md: '8px',
      lg: '10px',
      xl: '12px',
      xxl: '16px',
      xxxl: '24px',
      round: '50%'
    },
    width: {
      small: '1px',
      medium: '2px',
      large: '4px'
    }
  },
  shadow: {
    short: '0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.15)',
    medium: '2px -2px 6px rgba(0, 0, 0, 0.1), 2px 6px 10px rgba(0, 0, 0, 0.15)'
  },
  breakpoints: {
    contextMenuBreakpoint: 700
  },
  events: {
    modalOpenedOnPage: 'modal-opened-on-page'
  }
};
export default TscStyles;